/**
 * Vasim Hayat @ 2/10/2018
 */

export class FnLangConstant {
	public static readonly LANG_KEY = 'langID';

	public static readonly APP_LANGUAGE_HASH = {
		en: {
			langCode: 'en',
			// flag: 'flag-icon-us',
			flag: 'fn-flag-us',
			icon: 'app/extra/icons/usa_square_icon_64.png',
			name: 'EN',
			description: 'English',
		},
		es: {
			langCode: 'es',
			// flag: 'flag-icon-es',
			flag: 'fn-flag-spain',
			icon: 'app/extra/icons/spain_square_icon_64.png',
			name: 'ES',
			description: 'Spanish',
		},
		fr: {
			langCode: 'fr',
			// flag: 'flag-icon-fr',
			flag: 'fn-flag-france',
			icon: 'app/extra/icons/france_square_icon_64.png',
			name: 'FR',
			description: 'French',
		},
		zh: {
			langCode: 'zh',
			// flag: 'flag-icon-cn',
			flag: 'fn-flag-china',
			icon: 'app/extra/icons/china_square_icon_64.png',
			name: 'ZH',
      description: "Chinese",
		},
		it: {
			langCode: 'it',
			// flag: 'flag-icon-it',
			flag: 'fn-flag-italy',
			icon: 'app/extra/icons/italy_square_icon_64.png',
			name: 'IT',
			description: 'Italian',
		},
		de: {
			langCode: 'de',
			// flag: 'flag-icon-de',
			flag: 'fn-flag-germany',
			icon: 'app/extra/icons/germany_square_icon_64.png',
			name: 'DE',
      description: "German",
		},
	};

	public static readonly APP_LANGUAGES = [
		FnLangConstant.APP_LANGUAGE_HASH.en,
		FnLangConstant.APP_LANGUAGE_HASH.es,
		FnLangConstant.APP_LANGUAGE_HASH.fr,
		FnLangConstant.APP_LANGUAGE_HASH.zh,
		FnLangConstant.APP_LANGUAGE_HASH.it,
		FnLangConstant.APP_LANGUAGE_HASH.de,
	];
}
